import React from "react";

const RdvLocation = ({ rdv }) => (
  <>
    <p>
      Lieu :{" "}
      <span className="rdv-card__place">
        {rdv.site.organization.name} - {rdv.site.name}
      </span>
    </p>
    {rdv.comment && rdv.comment != "" && (
      <p className="rdv-card__quote">
        <i className="far fa-comment mr-2" aria-hidden="true" />
        <strong>Allocataire</strong> — {rdv.comment}
      </p>
    )}
  </>
);

export default RdvLocation;
